import { useState, useEffect, useCallback } from "react";
import ScannerView   from "./views/ScannerView";
import DetailView    from "./views/DetailView";
import HistoryView   from "./views/HistoryView";
import ConfigView    from "./views/ConfigView";
import PositionsView from "./views/PositionsView";
import AnalyticsView from "./views/AnalyticsView";
import LogsView      from "./views/LogsView";
import LoginView     from "./views/LoginView";
import { api }      from "./api";

const TABS = [
  ["scanner",   "⚡ Scanner"],
  ["positions", "📊 Positions"],
  ["analytics", "📈 Analytics"],
  ["history",   "📋 Historique"],
  ["logs",      "🔍 Logs"],
  ["config",    "⚙ Config"],
];

const CHAINS = ["ALL", "BSC", "SOLANA", "ETH"];

export default function App() {
  const [authed,   setAuthed]   = useState(() => !!localStorage.getItem("cs_token"));
  const [tab,      setTab]      = useState("scanner");
  const [signals,  setSignals]  = useState([]);
  const [chain,    setChain]    = useState("ALL");
  const [detail,   setDetail]   = useState(null);
  const [lastSync, setLastSync] = useState(null);
  const [theme,    setTheme]    = useState(() => localStorage.getItem("cs_theme") || "dark");

  useEffect(() => {
    document.body.classList.toggle("light", theme === "light");
    localStorage.setItem("cs_theme", theme);
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === "dark" ? "light" : "dark");

  const fetchSignals = useCallback(async () => {
    const data = await api.getSignals(chain);
    setSignals(data);
    setLastSync(new Date());
  }, [chain]);

  useEffect(() => {
    fetchSignals();
    const t = setInterval(fetchSignals, 30_000);
    return () => clearInterval(t);
  }, [fetchSignals]);

  const S = { background:"var(--bg)", minHeight:"100vh", padding:"16px 20px" };
  const NAV = { display:"flex", alignItems:"center", gap:10, marginBottom:16,
                borderBottom:"1px solid var(--border)", paddingBottom:12 };
  const LOGO = { fontSize:15, fontWeight:700, fontFamily:"'Syne',sans-serif",
                 color:"#00E5C0", letterSpacing:2, marginRight:"auto" };
  const BTN  = (active) => ({
    background: active ? "#00E5C033" : "transparent",
    color:      active ? "#00E5C0"   : "#555E6E",
    border:    `1px solid ${active ? "#00E5C044" : "#1C2030"}`,
    borderRadius: 6, padding:"6px 14px", fontSize:10,
    fontFamily:"'IBM Plex Mono',monospace", cursor:"pointer", letterSpacing:1,
  });

  if (!authed) return <LoginView onLogin={() => setAuthed(true)} />;

  return (
    <div style={S}>
      <nav style={NAV}>
        <span style={LOGO}>CRYPTOSCAN</span>
        {TABS.map(([k,l]) => (
          <button key={k} onClick={() => { setTab(k); setDetail(null); }} style={BTN(tab===k && !detail)}>
            {l}
          </button>
        ))}
        {CHAINS.map(c => (
          <button key={c} onClick={() => setChain(c)} style={{...BTN(chain===c), fontSize:9}}>
            {c}
          </button>
        ))}
        {lastSync && (
          <span style={{fontSize:9, color:"#2A3040", marginLeft:8}}>
            sync {lastSync.toLocaleTimeString()}
          </span>
        )}
        <button
          onClick={() => { localStorage.removeItem("cs_token"); setAuthed(false); }}
          style={{...BTN(false), marginLeft: "auto", fontSize: 9, color: "#E03030", borderColor: "#E0303033"}}
        >
          ⏻
        </button>
      </nav>

      {detail ? (
        <DetailView id={detail} onBack={() => setDetail(null)} />
      ) : tab === "scanner" ? (
        <ScannerView signals={signals} onDetail={setDetail} />
      ) : tab === "positions" ? (
        <PositionsView />
      ) : tab === "analytics" ? (
        <AnalyticsView />
      ) : tab === "history" ? (
        <HistoryView />
      ) : tab === "logs" ? (
        <LogsView />
      ) : (
        <ConfigView theme={theme} onToggleTheme={toggleTheme} />
      )}
    </div>
  );
}
